import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import PageOfferReport from '@pages/offer-report/ui/PageOfferReport';

function OfferReportRoute() {
  const { id } = Route.useParams();
  return <PageOfferReport idCampaign={id} />;
}

export const Route = createFileRoute('/_auth/_layout/offers_/report/$id')({
  component: OfferReportRoute,
});
